import { render, staticRenderFns } from "./powerText.vue?vue&type=template&id=9c11586c&scoped=true"
import script from "./powerText.vue?vue&type=script&lang=js"
export * from "./powerText.vue?vue&type=script&lang=js"
import style0 from "./powerText.vue?vue&type=style&index=0&id=9c11586c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c11586c",
  null
  
)

export default component.exports